import {PermissionAction, ResourceName} from "../features/auth/types";

export const PERMISSION_ACTIONS = ['index' , 'show' , 'create' , 'update', 'destroy'] as const
export const RESOURCES = ['Draft' , 'Creation', 'MediabankResource', 'Emission', 'Impression'] as const
export const RESOURCE_PATHS: {
    [key in string]: {
        [key: string]: string
    }
} = {
    ['Draft']: {
        index: '/',
        create: '/new-draft',
    },
    ['Creation']: {
        index: '/creations',
        create: '/new-creation',
    },
    ['MediabankResource']: {
        index: '/mediabank-resource',
    },
    ['Emission']: {
        index: '/emissions',
    },
    ['Impression']: {
        index: '/reports',
    },
}
